<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        class="reservationModal"
        hide-footer
        scrollable
        header-class="p-0 border-0"
        @hidden="close">
        <template #modal-header="{ close }">
            <div class="reservationDoctorMenusHeaderWrapper">
                <div class="reservationDoctorMenusHeaderNavWrapper">
                    <div class="reservationDoctorMenusHeaderNav d-flex align-items-center">
                        <h5 class="modal-title">{{ $locale.consultation_host }}メニューを選択</h5>
                        <button type="button" aria-label="Close" class="close" @click="close">×</button>
                    </div>
                    <div class="reservationDoctorMenusHeaderInfo d-block d-md-flex justify-content-center align-items-center">
                        <div class="d-block d-md-flex justify-content-center align-items-center">
                            <span>{{ $locale.consultation_host }}科:</span>
                            <span>{{ $store.state.reservation.medicalCourse.name }}</span>
                        </div>
                        <div
                            v-if="$store.state.configs.timezone == 1"
                            class="d-block d-md-flex justify-content-center align-items-center">
                            <span>&nbsp;&nbsp;タイムゾーン:</span>
                            <span>{{ $store.state.reservation.timezoneWithCurrentTime }}</span>
                        </div>
                    </div>
                </div>

                <div
                    v-if="allowDays > 0"
                    class="reservationDoctorMenusSearchWrapper">
                    <div class="reservationDoctorMenusSearchDateList d-flex justify-content-between align-items-center">
                        <div
                            class="reservationDoctorMenusSearchPrev d-flex justify-content-center align-items-center"
                            :class="{ 'hide' : currentPage <= 1 }"
                            @click="initSearchDates(currentPage - 1)">
                            ←
                        </div>
                        <ul>
                            <li
                                v-for="date in searchDates"
                                :class="{ 'current' : search.date === date.format('YYYY-MM-DD') }"
                                @click="onClickSearchDate(date.format('YYYY-MM-DD'))">
                                <div class="reservationDoctorMenusSearchDate">
                                    <div
                                        class="small"
                                        :class="{ 'sun' : date.day() === 0, 'sat' : date.day() === 6 }">
                                        {{ date.format('ddd') }}
                                    </div>
                                    <div>{{ date.format('M/D') }}</div>
                                </div>
                            </li>
                        </ul>
                        <div
                            class="reservationDoctorMenusSearchNext d-flex justify-content-center align-items-center"
                            :class="{ 'hide' : currentPage >= endOfPage }"
                            @click="initSearchDates(currentPage + 1)">
                            →
                        </div>
                    </div>
                    <div
                        class="reservationDoctorMenusSearchTimes"
                        :class="{ 'disabled' : search.date === null }">
                        <ul class="d-block d-md-flex justify-content-between align-items-stretch">
                            <li
                                @click="onClickSearchTime(null, null)"
                                class="d-flex align-items-center"
                                :class="{ 'current' : search.start === null && search.end === null }">
                                指定なし
                            </li>
                            <li
                                @click="onClickSearchTime(0, 6)"
                                class="d-flex align-items-center"
                                :class="{ 'current' : search.start === 0 && search.end === 6 }">
                                深夜&nbsp;(午前0:00-6:00)
                            </li>
                            <li
                                @click="onClickSearchTime(6, 12)"
                                class="d-flex align-items-center"
                                :class="{ 'current' : search.start === 6 && search.end === 12 }">
                                朝&nbsp;(午前6:00-12:00)
                            </li>
                            <li
                                @click="onClickSearchTime(12, 18)"
                                class="d-flex align-items-center"
                                :class="{ 'current' : search.start === 12 && search.end === 18 }">
                                昼&nbsp;(午後0:00-6:00)
                            </li>
                            <li
                                @click="onClickSearchTime(18, 24)"
                                class="d-flex align-items-center"
                                :class="{ 'current' : search.start === 18 && search.end === 24 }">
                                夜&nbsp;(午後6:00-12:00)
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>

        <div class="reservationDoctorMenusModalList">
            <template v-if="groupedDoctorMenus !== null">
                <div
                    v-if="groupedDoctorMenus.length > 0"
                    class="reservationDoctorMenusModalDoctorCount">
                    <span>{{ groupedDoctorMenus.length }}</span><!--
                        --><span>人</span><!--
                        --><span>の医師が見つかりました</span>
                </div>

                <div v-if="canMatching">
                    <user-reservation-matching-doctor-menu
                        :user="user"
                        :user-coupons="filteredUserCoupons"
                        :is-campaign="isCampaign">
                    </user-reservation-matching-doctor-menu>
                </div>

                <template v-if="groupedDoctorMenus.length > 0">
                    <div v-for="doctorMenus in groupedDoctorMenus">
                        <user-reservation-doctor-menu
                            :doctor-menus="doctorMenus"
                            :is-search-condition="isSearchCondition"
                            is-doctor-info>
                        </user-reservation-doctor-menu>
                    </div>
                </template>
                <template v-else-if="!canMatching">
                    <div class="d-flex justify-content-center align-items-center p-5 m-5">
                        <p class="text-muted m-0 p-0">
                            ご指定の{{ $locale.consultation_host }}科、時間帯に対応可能な医師が見つかりませんでした。
                        </p>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="d-flex justify-content-center align-items-center pt-5 p-4">
                    <b-spinner variant="yokumiru-user"></b-spinner>
                </div>
            </template>
        </div>
    </b-modal>
</template>

<script>
    import { mapMutations } from 'vuex'
    import constants from'../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'
    import moment from 'moment-timezone'
    import FPSManager from '../../../FPSManager'

    const fps = new FPSManager({ fps: 1 })

    export default {
        props: {
            isCampaign: {
                type: Boolean,
                default: false,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                user: null,
                doctorMenus: null,
                frame: null,
                currentPage: 1,
                searchDatesCount: 7,
                searchDates: [],
                search: {
                    date: null,
                    start: null,
                    end: null,
                },
                errors: {},
            }
        },

        computed: {
            /**
             * 予約可能日数
             * @return {number}
             */
            allowDays: function () {
                if (this.helper.hasSubscriptionPeriodEnd(this.user)) {
                    return this.helper.subscriptionDiffDays(this.user, true)
                }
                return this.$store.state.configs.reservation_allow_days
            },

            /**
             * マッチング予約可能かどうか
             * @return {boolean}
             */
            canMatching: function () {
                return !! this.$store.state.reservation?.medicalCourse?.can_matching
            },

            /**
             * 所持クーポンのフィルタリング
             * （相談予約カテゴリのクーポンだけにする）
             *
             * @return {array}
             */
            filteredUserCoupons: function () {
                if (!this.user) return []
                return this.helper.filteredUserCoupons(this.user)
            },

            /**
             * 医師でグルーピングされたメニューリスト
             * @return {null|array}
             */
            groupedDoctorMenus: function () {
                if (this.doctorMenus === null) {
                    return null
                }

                const sortedDoctorMenus = this.doctorMenus.sort((a, b) => {
                    const aDiscount = this.helper.maxDiscountCoupon(this.filteredUserCoupons, a)?.discount || 0
                    const bDiscount = this.helper.maxDiscountCoupon(this.filteredUserCoupons, b)?.discount || 0

                    if (aDiscount < bDiscount) return 1
                    if (aDiscount > bDiscount) return -1
                    return 0
                })

                const menus = []
                const doctorIds = []
                sortedDoctorMenus.forEach((doctorMenu) => {
                    if (!doctorIds.includes(doctorMenu.doctor_id)) {
                        doctorIds.push(doctorMenu.doctor_id)
                        menus.push([])
                    }
                    const idx = doctorIds.findIndex((doctorId) => doctorId === doctorMenu.doctor_id)
                    menus[idx].push(doctorMenu)
                })
                return menus
            },

            isSearchCondition: function () {
                return !!this.search.date || !!this.search.start || !!this.search.end
            },

            endOfPage: function () {
                if (!this.user) return 1

                if (this.helper.hasSubscriptionPeriodEnd(this.user)) {
                    const days = this.helper.subscriptionDiffDays(this.user, true)
                    return Math.ceil(days / this.searchDatesCount)
                }
                else {
                    const days = this.$store.state.configs.reservation_allow_days
                    return Math.ceil(days / this.searchDatesCount)
                }
            },
        },

        created: function() {
            bus.$on('open-modal-reservation-doctor-menus', this.open)
            bus.$on('close-modal-reservation-doctor-menus', this.close)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-reservation-doctor-menus')
            bus.$off('close-modal-reservation-doctor-menus')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function() {
                this.modalShow = true
                this.user = this.$store.state.reservation.user
                this.setMode('default')

                this.initSearch()
                this.startTimezoneTimer()
                this.fetchDoctorMenus()
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * タイムゾーン表記の現在時刻を進める
             */
            startTimezoneTimer: function() {
                this.frame = requestAnimationFrame(this.startTimezoneTimer)
                fps.tick(this.elapse)
            },

            elapse: function () {
                if (this.user) {
                    const timezone = this.user.timezone

                    let time = moment().tz(this.user.timezone).format('ah:mm')
                    if (time.includes('午前12')) {
                        time = time.replace('午前12', '午前0')
                    }

                    this.setTimezoneWithCurrentTime(`${timezone}（${time}）`)
                }
            },

            /**
             * 医師メニュー一覧取得
             */
            fetchDoctorMenus: function () {
                this.doctorMenus = null
                const endpoint = constants.user.medical_courses.endpoint.base
                let query = '?'

                // 日付・時間が両方指定されている場合
                if (this.search.date !== null && this.search.start !== null && this.search.end !== null) {
                    const start = moment.tz(`${this.search.date} 00:00:00`, this.user.timezone).hours(this.search.start).tz('Asia/Tokyo')
                    const end = moment.tz(`${this.search.date} 00:00:00`, this.user.timezone).hours(this.search.end).tz('Asia/Tokyo')

                    query += `start=${start.format('YYYY-MM-DD HH:mm:ss')}&`
                    query += `end=${end.format('YYYY-MM-DD HH:mm:ss')}&`
                }
                // 日付のみ指定されている場合
                else if (this.search.date !== null && (this.search.start === null || this.search.end === null)) {
                    const start = moment.tz(`${this.search.date} 00:00:00`, this.user.timezone).tz('Asia/Tokyo')
                    const end = moment.tz(`${this.search.date} 00:00:00`, this.user.timezone).add(1, 'days').tz('Asia/Tokyo')

                    query += `start=${start.format('YYYY-MM-DD HH:mm:ss')}&`
                    query += `end=${end.format('YYYY-MM-DD HH:mm:ss')}&`
                }

                axios.get(`${endpoint}/${this.$store.state.reservation.medicalCourse.id}/doctor_menus${query.slice(0, -1)}`)
                    .then(({data}) => {
                        this.doctorMenus = data.data
                    })
            },

            /**
             * 日時検索エリアの初期化
             */
            initSearch: function () {
                this.initSearchStatus()
                this.initSearchDates()

                // 日付検索のクエリパラメータが存在する場合
                // @see https://github.com/sewii/yokumiru_mobile/issues/395
                if (this.search.date) {
                    let hasDate = this.searchDates.some((date) => date.format('YYYY-MM-DD') === this.search.date)

                    while (!hasDate && this.currentPage < this.endOfPage) {
                        this.currentPage++
                        this.initSearchDates(this.currentPage)
                        hasDate = this.searchDates.some((date) => date.format('YYYY-MM-DD') === this.search.date)
                    }

                    if (!hasDate) {
                        this.clearSearch()
                    }
                }
            },

            /**
             * 日時検索の条件を初期化
             */
            initSearchStatus: function () {
                const date = this.$route.query.start_date || null
                let start = this.$route.query.start_time || null
                let end = null

                if (date && date.match(/2[0-9]{3}-[0-9]{2}-[0-9]{2}/u)) {
                    if (start && start.match(/[0-9]{2}:[0-9]{2}/u)) {
                        start = Number(start.substring(0, 2))
                        end = start + 6
                    }
                    this.search = {
                        date,
                        start,
                        end,
                    }
                }

                this.setSearchDate(this.search.date)
                this.setSearchStartTime(this.search.start)
            },

            /**
             * 日時検索の日付リストを初期化
             *
             * @param {number} page
             */
            initSearchDates: function (page = 1) {
                if (!this.user) return

                if (page < 1) {
                    this.currentPage = 1
                }
                else if (page <= this.endOfPage) {
                    this.currentPage = page
                }

                const limitDate = this.helper.userTimeNow(this.user.timezone).endOf('day').add(this.allowDays, 'days')
                const date = this.helper.userTimeNow(this.user.timezone).startOf('day')
                date.add((this.currentPage - 1) * this.searchDatesCount, 'days')

                this.searchDates = []
                for (let i = 1; i <= this.searchDatesCount; i++) {
                    const d = date.clone().add(i, 'days')
                    if (d.isSameOrBefore(limitDate)) {
                        this.searchDates.push(date.clone().add(i, 'days'))
                    }
                }
            },

            /**
             * 検索条件のクリア
             */
            clearSearch: function () {
                this.search = {
                    date: null,
                    start: null,
                    end: null,
                }
                this.currentPage = 1
                this.initSearchDates()
            },

            /**
             * 検索日付クリック時
             *
             * @param {moment} date
             */
            onClickSearchDate: function (date) {
                this.search.date = this.search.date === date ? null : date
                this.search.start = null
                this.search.end = null

                this.setSearchDate(this.search.date)
                this.setSearchStartTime(null)

                this.fetchDoctorMenus()
            },

            /**
             * 検索時間クリック時
             *
             * @param {number|null} start
             * @param {number|null} end
             */
            onClickSearchTime: function (start, end) {
                if (this.search.date === null) return
                
                const isChanged = this.search.start !== start || this.search.end !== end

                this.search.start = start
                this.search.end = end

                if (isChanged) {
                    this.fetchDoctorMenus()
                }
            },

            ...mapMutations({
                setMode: 'reservation/setMode',
                setTimezoneWithCurrentTime: 'reservation/setTimezoneWithCurrentTime',
                setSearchDate: 'reservation/setSearchDate',
                setSearchStartTime: 'reservation/setSearchStartTime',
            }),
        },
    }
</script>

<style lang="scss" scoped>
.reservationDoctorMenusHeaderWrapper {
    width: 100%;

    .reservationDoctorMenusHeaderNavWrapper {
        .reservationDoctorMenusHeaderNav {
            padding:1rem;
            border-bottom:1px solid #dee2e6;
        }

        .reservationDoctorMenusHeaderInfo {
            height: 50px;
            line-height: 50px;
            color: #757C83;
            font-size: 14px;
            text-align: center;
            background-color: #F8F8F8;
            border-bottom: 1px solid #dee2e6;

            @media screen and (max-width: 767px) {
                height: auto;
                line-height: 1.4;
                padding: 5px 0;
                font-size: 12px;
            }

            span {
                &:nth-child(2),
                &:nth-child(4) {
                    color: #497EAF;
                    font-size: 16px;
                    font-weight: bold;

                    @media screen and (max-width: 767px) {
                        font-size: 14px;
                    }
                }
            }
        }
    }

    .reservationDoctorMenusSearchWrapper {
        padding: 10px 20px;
        background: #f8f8f8;
        border-bottom: 1px solid #dee2e6;
        box-sizing: border-box;

        @media screen and (max-width: 767px) {
            height: 160px;
            overflow-y: scroll;
        }

        .reservationDoctorMenusSearchPrev,
        .reservationDoctorMenusSearchNext {
            width: 30px;
            height: 30px;
            line-height: 30px;
            color: #7D868D;
            font-size: 14px;
            text-align: center;
            background: #fff;
            border: 1px solid #e0e0e0;
            border-radius: 50%;
            cursor: pointer;

            &.hide {
                visibility: hidden !important;
            }
        }

        .reservationDoctorMenusSearchDateList {
            max-width: 680px;
            margin: 0 auto;

            ul {
                width: 100%;
                margin: 0;
                padding: 0 15px;
                list-style: none;

                @media screen and (max-width: 767px) {
                    display: flex;
                    justify-content: center;
                }

                @media screen and (max-width: 500px) {
                    display: block;
                }

                li {
                    position: relative;
                    display: inline-block;
                    width: 60px;
                    height: 60px;
                    margin: 2px 12px;
                    color: #333;
                    background: #F0C72F;
                    text-align: center;
                    border-radius: 50%;
                    cursor: pointer;

                    @media screen and (max-width: 767px) {
                        width: 44px;
                        height: 44px;
                        margin: 2px 3px
                    }

                    &.current {
                        color: #fff;
                        background: #ef7320;

                        &:hover::before {
                            content: '×';
                            position: absolute;
                            top: 0;
                            right: 0;
                            display: block;
                            width: 20px;
                            height: 20px;
                            line-height: 20px;
                            color: #fff;
                            font-size: 14px;
                            text-align: center;
                            background: #eea473;
                            border-radius: 50%;
                        }

                        .reservationDoctorMenusSearchDate {
                            div {
                                &:nth-child(1) {
                                    color: #fff !important;
                                }
                            }
                        }
                    }

                    .reservationDoctorMenusSearchDate {
                        line-height: 1.3;

                        @media screen and (max-width: 767px) {
                            line-height: 1;
                        }

                        div {
                            &:nth-child(1) {
                                margin-top: 12px;
                                color: #2A2E31;
                                font-weight: bold;

                                @media screen and (max-width: 767px) {
                                    margin-top: 9px;
                                }

                                &.sun {
                                    color: #dc3545;
                                }

                                &.sat {
                                    color: #417daf;
                                }
                            }
                        }
                    }
                }
            }
        }

        .reservationDoctorMenusSearchTimes {
            max-width: 720px;
            margin: 10px auto 0;

            &.disabled {
                opacity: 0.5;
                
                ul {
                    li {
                        cursor: default;
                    }
                }
            }

            ul {
                width: 100%;
                margin: 0;
                padding: 0;
                list-style: none;

                li {
                    margin: 0 4px;
                    padding: 5px 12px;
                    color: #333;
                    font-size: 13px;
                    background: #fbeaad;
                    text-align: center;
                    border-radius: 8px;
                    cursor: pointer;

                    @media screen and (max-width: 767px) {
                        padding: 8px 12px;
                        margin-bottom: 5px;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }

                    &.current {
                        color: #fff;
                        background: #ef7320;
                        cursor: default;
                    }
                }
            }
        }
    }
}

.reservationDoctorMenusModalDoctorCount {
    margin-left: 22px;

    span {
        color: #757C83;
        font-size: 16px;

        &:nth-child(1) {
            position: relative;
            top: 1px;
            color: #2A2E31;
            font-size: 24px;
            font-weight: bold;
        }
        &:nth-child(2) {
            color: #2A2E31;
            font-weight: bold;
        }
    }
}
</style>
